import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Area } from '../../core/constants/area';
import { FailedLoginItem } from './failed-logins/models/failed-login-item.model';

@Injectable()
export class AuthToolsService {
  constructor(public httpClient: HttpClient) { }

  getFailedLogins() {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/failedLogins`;
    return this.httpClient.get<Array<FailedLoginItem>>(url);
  }

  removeLockout(userId: string) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/userLockout/${userId}/reset`;
    return this.httpClient.patch<void>(url, null);
  }

  lockoutUser(userId: string) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/userLockout/${userId}`;
    return this.httpClient.patch<void>(url, null);
  }

  setUserPassword(userEmail: string, newPassword: string) {
    const url = `${environment.dotNetApiUrl}/${Area.auth}/ForgotPassword/SetPassword`;
    const body = { email: userEmail, password: newPassword };
    return this.httpClient.post<any>(url, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/auth-tools/auth-tools.service.ts